import React from 'react';

function Footer() {
  return (
    <footer className="bg-green-800 text-white py-8 mt-8">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="text-green-200">&copy; {new Date().getFullYear()} Glenullin GAC. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer; 